import type { CSSProperties } from 'react'

interface TlaaqWordmarkProps {
  size?: number
  color?: string
  style?: CSSProperties
}

export function TlaaqWordmark({ size = 28, color = 'var(--brand-900)', style }: TlaaqWordmarkProps) {
  return (
    <span
      className="wordmark"
      style={{ fontSize: size, color, lineHeight: 1.2, ...style }}
    >
      tlaaq
    </span>
  )
}

interface TlaaqLogoProps {
  height?: number
  reverse?: boolean
  variant?: 'onDark' | 'default'
}

export function TlaaqLogo({ height = 28, reverse = false, variant }: TlaaqLogoProps) {
  const isOnDark = reverse || variant === 'onDark'

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: height / 4 }}>
      <img
        src="/tlaaq-app-icon.svg"
        alt=""
        width={height}
        height={height}
        style={{ display: 'block', flexShrink: 0 }}
      />
      <TlaaqWordmark
        size={height / 1.2}
        color={isOnDark ? 'var(--white)' : 'var(--brand-900)'}
        style={{ display: 'inline-block', lineHeight: `${height}px` }}
      />
    </span>
  )
}
